<template>
<AppLayout>
  <div class="transaction">
    <section id="transaction-products">
        <div class="container">
  
          <h6 style="margin-bottom: 0px;" class="fw-bold">Purchases</h6>
          <div class="warehouse-inventory-card-wrapper">
            <div class="warehouse-inventory-card">
              <p>Purchase Orders this Month</p>
              <strong class="blue">{{purchasesMonth }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Purchase Orders Pending Approval</p>
              <strong class="blue">{{ purchasePending }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Purchase Orders Fulfilled</p>
              <strong class="blue">{{ purchasefulfilled }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Cancelled Purchase Orders</p>
              <strong class="red">{{ purchaseCancel }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Rejected Purchase Orders</p>
              <strong class="red">{{ purchaseReject }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p class="orange">Value of POs</p>
              <strong class="orange">Kshs {{ purchaseValue }}</strong>
            </div>
  
          </div> 
  
          <div class="filter-search" style="margin-top: 0px; padding-left: 0px;">
            <div class="filter-search-header">
              <p>Filter</p>
              <p class="clear" @click="clear">Clear</p>
            </div>
            <div class="filter-search-body">
              <div class="form">
                <div class="row">
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date From</label>
                      <input type="date" class="form-control" v-model="dateFrom">
                    </div>
                  </div>

                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date To</label>
                      <input type="date" class="form-control" v-model="dateTo">
                    </div>
                  </div>

                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">PO No.</label>
                      <input type="text" class="form-control" v-model="poNo">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Status</label>
                      <select class="full" id="handled-by" v-model="status">
                        <option value="all">All</option>
                        <option value="pending">Pending</option>
                        <option value="active">Approved</option>
                        <option value="rejected">Rejected</option>
                        <option value="fulfilled">Fulfilled</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Raised By</label>
                      <select class="full" id="handled-by" v-model="raisedById">
                        <option value="0">Any</option>
                        <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Approved By</label>
                      <select class="full" id="handled-by" v-model="approvedById">
                        <option value="0">Any</option>
                        <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!--
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Amount/Value</label>
                      <input type="number" class="form-control"  v-model="amount">
                    </div>
                  </div>
                  -->
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Project</label>
                      <input type="text" class="form-control" v-model="project">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Department</label>
                      <input type="text" class="form-control" v-model="departmentId">
                    </div>
                  </div>
                  
                  <div class="col-md-1 align-self-end">
                    <div class="form-group">
                      <button class="btn-style small" @click="search">Search</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="products-list transaction-products-list"  style="margin-top: 0px;">
                <!-- <keep-alive> -->
                <table id="purchasesTable" class="table table-hover">
                    <thead>
                        <th>No.</th>
                        <th>Date</th>
                        <th>PO No.</th>
                        <th>Department</th>
                        <th>Project</th>
                        <th>Raised By</th>
                        <th>Status</th>
                        <th>Exception</th>
                        <th>Fulfilled By</th>
                        <th>Amount</th>
                        <th>Action</th>
                    </thead>
                </table>
                <LoaderItem v-if="loading"/>
              <!-- </keep-alive> 
                <div v-if="purchases.length < 1">
                  <label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No purchase found</label>
                </div>-->
                
                <!-- Discrepancies Modal -->
                <div v-if="showDiscrepanciesModal" class="modal-overlay">
                  <div class="modal-content">
                    <h4>Discrepancies</h4>
                    <table class="table table-sm">
                      <thead>
                        <th>Product</th>
                        <th>Original Qty</th>
                        <th>Fulfilled Qty</th>
                        <th>Remaining Qty</th>
                        <th>Batch Qty</th>
                        <th>Qty Diff</th>
                        <th>Purchase Price</th>
                        <th>Batch Price</th>
                        <th>Price Diff</th>
                      </thead>
                      <tbody>
                        <tr v-for="it in discrepanciesItems" :key="it.productId">
                          <td>{{ it.productName }}</td>
                          <td>{{ formatNumberSimple(it.originalQty) }}</td>
                          <td>{{ formatNumberSimple(it.alreadyReceived) }}</td>
                          <td>{{ formatNumberSimple(it.remainingQty) }}</td>
                          <td>{{ formatNumberSimple(it.batchQty) }}</td>
                          <td>{{ formatNumberSimple(it.qtyDiff) }}</td>
                          <td>{{ formatCurrency(it.purchasePrice) }}</td>
                          <td>{{ formatCurrency(it.batchPrice) }}</td>
                          <td>{{ formatCurrency(it.priceDiff) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div style="margin-top: 8px; display:flex; gap:8px; justify-content:flex-end;">
                      <div style="align-self:center; font-weight:bold">Totals:</div>
                      <div style="align-self:center">Qty: {{ formatNumberSimple(discrepancyTotals?.totalQuantityDiscrepancy || 0) }}</div>
                      <div style="align-self:center">Price: {{ formatCurrency(discrepancyTotals?.totalPriceDiscrepancy || 0) }}</div>
                      <button class="btn btn-default" @click="closeDiscrepancies">Close</button>
                    </div>
                  </div>
                </div>
          </div>
        </div>
    </section>
  </div>
</AppLayout>
</template>
  
  <script>
  import { docFooter } from '../../utils/common'
  import { mapGetters, mapActions } from 'vuex'
  // sweetalert replaced by vuetoastify toasts
  import AppLayout from '../../components/AppLayout.vue';
  import LoaderItem from '../../components/LoaderItem'
  import 'datatables.net-vue3';
  import 'datatables.net-bs5';
  import "datatables.net-buttons-bs5";
  import "datatables.net-responsive-bs5";
  import $ from 'jquery';
  import 'jszip';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.colVis.js';
  import 'datatables.net-buttons/js/buttons.print.js';

  export default {
    name: 'HomePurchases',
    components: {
      AppLayout,
      LoaderItem
    },

    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        purchasesMonth:0,
        purchasePending: 0,
        purchasefulfilled: "0/0",
        purchaseCancel:0,
        purchaseReject: 0,
        purchaseValue: "0",
        purchases: [],
        dateFrom: '', 
        dateTo: '',
        status: "", 
        raisedById: 0, 
        approvedById: 0, 
        dataTable:  null,
        processedData: [],
        loading: false, 
        amount: 0.0, 
        project: "", 
        departmentId: "",
        poNo: "",
        purchaseDatas: [],
        showDiscrepanciesModal: false,
        discrepanciesItems: [],
        discrepancyTotals: {},

    }),
      mounted(){
        this.fetchUsers()
        this.getPurchases()
      window.deleteAlert = this.deleteAlert;
      window.openDiscrepancies = this.openDiscrepancies;
      // expose the global name used by HomeOrders (inline onClick style)
      window.showDiscrepancies = this.openDiscrepancies;
    },

    computed:{
      ... mapGetters (["getUsers"]),
      users () { return this.getUsers },
    },
    methods:{
      ... mapActions(["fetchUsers"]),
      formatNumberSimple(val) {
        try {
          return new Intl.NumberFormat('en-US').format(Number(val || 0));
        } catch (e) {
          return val;
        }
      },
      formatCurrency(val) {
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES', maximumFractionDigits: 2 }).format(Number(val || 0));
        } catch (e) {
          return val;
        }
      },
      preprocessData(rawData) {
        return rawData.map(item => {
          let status =  "";
          let purchaseNo =  "";
          let exception =  "";
          let fulfilledName =  "";

          if(item.batchNo){
            purchaseNo = `${item.purchaseNo} <span style="font-size: 14px;"> - ${item.batchNo}</span>`
          } else {
            purchaseNo = item.purchaseNo
          }

          if(item.exception == 0){
            exception = '<button class="btn btn-primary btn-sm" style="margin-left: 5px; border-radius: 10px">OK</button>'
          } else {
            exception = '<button class="btn btn-danger btn-sm" style="margin-left: 5px; border-radius: 10px">!</button>'
          }
          

          if(item.fulfilledName){
            fulfilledName = item.fulfilledName
          } else {
            fulfilledName = ' - '
          }
          
          // normalize status for comparisons
          const st = (item.status || '').toString().toLowerCase();
          if(st == 'completed'){
            status = '<button class="btn btn-success btn-sm" style="text-transform: capitalize; border-radius: 15px">Completed</button>'
          } else if(st == 'fulfilled'){
            status = '<button class="btn btn-primary btn-sm" style="text-transform: capitalize; border-radius: 15px">Fulfilled</button>'
          } else if(st == 'partial' || st == 'partially' || st == 'partially_fulfilled'){
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize; border-radius: 15px">Partially fulfilled</button>'
          } else if(st == 'cancelled'){
            status = '<button class="btn btn-danger btn-sm" style="text-transform: capitalize; border-radius: 15px">Cancelled</button>'
          } else if(st == 'rejected'){
            status = '<button class="btn btn-danger btn-sm" style="text-transform: capitalize; border-radius: 15px">Rejected</button>'
          } else if(st == 'approved'){
            // Procurement approved -> yellow badge
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize; border-radius: 15px">Procurement approved</button>'
          } else if(st == 'verified'){
            // HOD approved -> orange badge
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize; background-color: orange; border-radius: 15px">HOD approved</button>'
          } else if(st == 'stamped'){
            // Finance approved: green if canBeFulfilled, orange otherwise
            const rawCan = (item.canBeFulfilled !== undefined && item.canBeFulfilled !== null) ? item.canBeFulfilled : item.canBefulfilled;
            const canFulfill = (typeof rawCan === 'boolean' && rawCan === true)
              || (typeof rawCan === 'string' && ['true', '1', 'yes'].includes(rawCan.toLowerCase()))
              || (Number(rawCan) === 1);
            if (canFulfill) {
              status = '<button class="btn btn-success btn-sm" style="text-transform: capitalize; border-radius: 15px">Finance approved</button>'
            } else {
              status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize; background-color: orange; border-radius: 15px">Finance approved</button>'
            }
          } else if(st == 'pending'){
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize; border-radius: 15px" >Pending</button>'
          } else if(st == 'saved' || st == 'draft'){
            // Saved should display as Draft
            status = '<button class="btn btn-secondary btn-sm" style="text-transform: capitalize; border-radius: 15px">Draft</button>'
          } else {
            status = `<button class="btn btn-default btn-sm" style="text-transform: capitalize; border: 1px solid #000000; border-radius: 15px" >${item.status}</button>`
          }

          return {
            indexNo:"1",
            createdAt: this.formatDate(item.createdAt),
            purchaseNo,
            // prefer joined Department name (department) or fallback to various fields
            department: (item.department && item.department !== '') ? item.department : (item.departmentName || (item.Department && item.Department.name) || ''),
            project: item.project,
            raisedName: item.name,
            status,
            exception,
            fulfilledName,
            amount: this.formatMoney(item.amount),
            action:'',
            itemId: item.id,
            hasException: !!item.exception,
            statusRow: item.status
          };
        });
      },

      reinitializeTable(){
        this.dataTable.clear()
        this.dataTable.rows.add(this.preprocessData(this.purchaseDatas))
        this.dataTable.draw()
      },


    clear(){
        this.status = ""
        this.raisedById = 0
        this.approvedById = 0
        this.amount = 0.0
        this.projectId = 0
        this.departmentId = ""
        this.poNo= ""
        this.reinitializeTable()
      }, 

      initializeDataTable() {
        try{
          this.dataTable = $(this.$el).find('#purchasesTable').DataTable({
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            destroy: true,
            dom: 'Bfrtip',
            buttons: [  
            'colvis',
            'pageLength', 
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary',
              exportOptions: {
                columns: ':visible', 
              },
            },
            {
                extend: 'pdfHtml5',
                text: 'Export PDF',
                className: 'btn btn-primary',
                orientation: 'landscape', 
                exportOptions: {
                  columns: ':visible', 
                },
                customize: this.customizePDF
              },
          ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: 'createdAt' },
              { data: 'purchaseNo' }, 
              { data: 'department' }, 
              { data: 'project' }, 
              { data: 'raisedName' }, 
              { data: 'status' }, 
              { data: 'exception' },
              { data: 'fulfilledName' }, 
              { data: 'amount' }, 
              { data: 'action', render:this.renderActionButton }
            ],
            columnDefs: [
              {
                targets: 0,  searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });

          // attach delegated handlers for buttons rendered inside the DataTable
          const $table = $(this.$el).find('#purchasesTable');
          // discrepancies buttons use inline onClick (showDiscrepancies); keep delete handler
          $table.off('click', '.btn-delete').on('click', '.btn-delete', (e) => {
            const id = $(e.currentTarget).data('id');
            console.debug('btn-delete clicked, id=', id);
            this.deleteAlert(id);
          });

        } catch(error){
          console.log({error})
        }
      },

      closeDiscrepancies(){
        this.showDiscrepanciesModal = false;
        this.discrepanciesItems = [];
        this.discrepancyTotals = {};
      },

      renderActionButton(data, type, row) {
        if (type === 'display') {
          let action = '';
          // show delete only when purchase is in 'saved' state
          const status = (row.statusRow || '').toString().toLowerCase();
          if (status === 'saved' || status === 'draft') {
            action += `<button class="btn btn-sm btn-danger btn-delete" style="margin-right: 10px;" data-id="${row.itemId}">Delete</button>`;
          }
          // only show discrepancies button when the purchase is partially fulfilled
          if (status === 'partial' || status === 'partially' || status === 'partially_fulfilled') {
            action += `<button class="btn btn-sm btn-secondary btn-discrepancies" style="margin-right: 10px;" data-id="${row.itemId}" onClick="showDiscrepancies(${row.itemId})">Discrepancies</button>`;
          }
          action += `<a class="btn btn-sm btn-default" style="border: 1px solid black; padding-top:1px !important; padding-bottom: 1px !important" href="/purchases/pdf/${row.itemId}">View</a>`;
          return action;
        }
        return data;
      },
     

      async search(){
        console.log("Raised by Id",this.raisedById)
        console.log("Approved by Id", this.approvedById)
        console.log(this.approvedById)
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                poNo: this.poNo,
                status: this.status, 
                raisedById: this.raisedById, 
                approvedById: this.approvedById,
                amount: this.amount,
                project: this.project,
                departmentId: this.departmentId,
            })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases/search', requestOptions)
        const data = await res.json()
        console.log("Response", data)
        if(data.status == true){
            this.purchases = data.purchases
            this.dataTable.clear();
            this.dataTable.rows.add(this.preprocessData(this.purchases));
            this.dataTable.draw();
        }else{
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Search failed. Try again')
        }
      },

      customizePDF(doc) {
        const profile = JSON.parse(localStorage.getItem('profile'))
        doc.pageMargins = [40, 40, 40, 40]; 
        doc.defaultStyle.columnGap = 0
        doc.content[1].fillColor = '#ffffff'

        doc.header = () => {
          return {
            columns: [
              {
                width: '*',
                columns: [
                  /* {
                      image: logoBase64,
                      width: 150, // Adjust the width as needed
                  },*/
                  {
                    text: profile?.businessName,
                    alignment: 'left',
                    margin: [40, 15, 0, 40], // Adjust margins as needed
                    color: '#FFA500', // Orange color
                    bold: true,
                    fontSize: 14,

                  }
                ]
              },
              {
                width: '*',
                stack: [
                  {
                    text: 'Purchases',
                    alignment: 'right',
                    margin: [0, 15, 50, 0],
                    fontSize: 12,
                    color: '#000000'
                  },
                  {  
                    alignment: 'right',
                    margin: [300, 0, 0, 0],
                    width: '*',
                    columns: [
                      {
                        width: 'auto',
                        text: 'Date:',
                        alignment: 'right',
                        margin: [0, 0, 10, 0],
                        bold: true,
                      },
                      {
                        width: 'auto',
                        text: `${this.formatDate(new Date(), "true")}`,
                        alignment: 'right',
                        margin: [0, 0, 50, 0],
                        fontSize: 9
                      }
                    ]
                  }
                ]
              }
            ],
            fillColor: '#000000'
          };
        },

        doc.footer = (currentPage, pageCount) => docFooter(currentPage, pageCount)

        doc.styles.title = {
          color: '#000000',
          fontSize: 13,
          margin: [80, 0, 0, 40],
        };
      },


      async getPurchases () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          
          try{
            this.loading = true
            const res = await fetch(process.env.VUE_APP_URL+'/purchases', requestOptions)
            const data = await res.json()
            this.purchases = data.purchases || []
            console.log(this.purchases)
            this.purchaseDatas = this.purchases
            this.processedData = this.preprocessData(this.purchases);

            // compute summary metrics for the dashboard cards
            const purchasesArr = this.purchases || [];
            const now = new Date();
            const currentMonth = now.getMonth();
            const currentYear = now.getFullYear();
            this.purchasesMonth = purchasesArr.filter(p => {
              const d = p.createdAt ? new Date(p.createdAt) : null;
              return d && d.getMonth() === currentMonth && d.getFullYear() === currentYear;
            }).length;
            this.purchasePending = purchasesArr.filter(p => (p.status || '').toString().toLowerCase() === 'pending').length;
            const fulfilledCount = purchasesArr.filter(p => {
              const s = (p.status || '').toString().toLowerCase();
              return s === 'fulfilled' || s === 'completed';
            }).length;
            this.purchasefulfilled = `${fulfilledCount}/${purchasesArr.length}`;
            this.purchaseCancel = purchasesArr.filter(p => (p.status || '').toString().toLowerCase() === 'cancelled').length;
            this.purchaseReject = purchasesArr.filter(p => (p.status || '').toString().toLowerCase() === 'rejected').length;
            const totalValue = purchasesArr.reduce((acc, p) => acc + (Number(p.amount) || 0), 0);
            this.purchaseValue = new Intl.NumberFormat('en-US').format(totalValue);
            //if(typeof this.dataTable == 'null'){
            this.dataTable = null;
            this.initializeDataTable();
            // close any open discrepancies modal when leaving
            this.showDiscrepanciesModal = false;
            // } else {
            //   this.dataTable.destroy()
            //   this.dataTable = null;
            //   this.initializeDataTable();
            // }
          }catch(err){
              console.log(err)
          }finally{
              this.loading = false
          }
      },
      deleteAlert(id){
          // replace modal confirm with native confirm and show toast notifications
          const confirmed = window.confirm('Confirm Purchase Order Deletion. This action cannot be reverted. Proceed?');
          if (confirmed) {
            this.deletePurchase(id);
          } else {
            if (this.$toast && typeof this.$toast.info === 'function') this.$toast.info('Deletion cancelled');
          }
      },

      // Discrepancies modal rendering data below

      async deletePurchase(id) {
        const requestOptions = {
              method: "DELETE",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token }
          };
          try{
            this.loading = true;
            const res = await fetch(process.env.VUE_APP_URL+'/purchases/'+id, requestOptions)
            const data = await res.json()
            if(data.status == true){
                if (this.$toast && typeof this.$toast.success === 'function') this.$toast.success('Saved Purchase Order deleted successfully');
              this.getPurchases()
              this.clear()
            }else{
                if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Purchase Order not deleted');
            }
          }catch(e){
            console.error(e);
            if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to delete purchase order');
          }finally{
            this.loading = false;
          }
      },

      async openDiscrepancies(purchaseId){
        console.debug('openDiscrepancies called with', purchaseId);
        try{
          const requestOptions = { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer '+this.token } };
          const res = await fetch(process.env.VUE_APP_URL+`/purchases/${purchaseId}/discrepancies`, requestOptions);
          const data = await res.json();
          if(data.status == true){
            const items = data.items || [];
            const totals = data.totals || {};

            // populate the Vue modal with discrepancies and show it
            this.discrepanciesItems = items;
            this.discrepancyTotals = totals;
            this.showDiscrepanciesModal = true;
          } else {
            if (this.$toast && typeof this.$toast.info === 'function') this.$toast.info(data.message || 'No discrepancies found');
          }
        }catch(e){
          console.error(e);
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to load discrepancies');
        }
      }
    },
    beforeRouteLeave() {
      if (this.dataTable && typeof this.dataTable.destroy === 'function') {
        this.dataTable.destroy();
        this.dataTable = null
      }
    }

  }
  </script>

  <style scoped>
  .purchases-list{
    padding: 20px;
    margin-top: 30px;
    box-shadow: rgba(49, 32, 104, 0.2) 0 2px 8px 0;
  }
  /* Prevent horizontal scroll: ensure table fits its container and buttons wrap */
  .purchases-list{
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .purchases-list table{
    width: 100%;
    max-width: 100%;
    table-layout: auto;
    box-sizing: border-box;
  }
  .purchases-list table th,
  .purchases-list table td{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
  /* allow DataTables buttons to wrap to next line instead of forcing extra width */
  .purchases-list .dt-buttons{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  </style>